export default "__VITE_ASSET__79e0fce8__"